import { render, staticRenderFns } from "./BtnMapa.vue?vue&type=template&id=78fc70e6&scoped=true"
import script from "./BtnMapa.vue?vue&type=script&lang=js"
export * from "./BtnMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc70e6",
  null
  
)

export default component.exports